import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_card_connect_event.js";
//#region src/bite_log_card_connect_event_helper.ts
var bite_log_card_connect_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 1: return "terminal-disconnected";
		case 2: return "update-idle-text-error";
		case 7: return "transaction-authorization-and-capture";
	}
}
//#endregion
export { bite_log_card_connect_event_helper_exports, name };

//# sourceMappingURL=bite_log_card_connect_event_helper.js.map